/**
 * Itens da LC 116 em que a NFS-e leva o grupo de construção civil/obra
 * (rejeição E630 de Fortaleza, out/2026): código da obra, ART, CNO (campo
 * `cei` do PlugNotas), inscrição do IPTU e endereço da obra. Os campos são
 * todos opcionais (confirmado pelo contador); a etapa aparece, não trava.
 */
export const ITENS_CONSTRUCAO_CIVIL = [
  "0702",
  "0704",
  "0705",
  "0706",
  "0707",
  "0708",
  "0717",
  "0719"
];

const digitos = (value: unknown) => (value ?? "").toString().replace(/\D/g, "");

/** O código do serviço (4 ou 6 dígitos) é de um item de construção civil? */
export function servicoExigeObra(codigo: unknown): boolean {
  return ITENS_CONSTRUCAO_CIVIL.includes(digitos(codigo).slice(0, 4));
}
